import { Box, IconButton, Tooltip, } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useAppbar, useMathcesDown, } from '../../hooks';
import SwipeableDrawerMenu from './swiperable-drawer-menu/SwipeableDrawerMenu';

export default function  ControlSwipeableDrawerMenu({ pages, }) {
    const { drawerMenuOpen, } = useAppbar();
    const matchesLg = useMathcesDown('lg');

    return (
        <Box sx={[
            { display: 'none', },
            matchesLg && {
                display: 'flex',
            }]}>
            <Tooltip title='Открыть меню' placement='right' arrow>
                <IconButton
                    aria-label='Open the main menu'
                    aria-controls='menu-appbar'
                    aria-haspopup='true'
                    onClick={drawerMenuOpen}
                    sx={{ color: 'text.primary', p: 0,}}>
                    <MenuIcon sx={{fontSize: [24, 26, 28,]}} />
                </IconButton>
            </Tooltip>
            <SwipeableDrawerMenu pages={pages} />
        </Box>
    );
}